class BaseInfoModel {
    id: number;
    baseKindId: number;
    title: string;
    color: string;
    textColor: string;
    sysName: string;
    staticForm: boolean;
    orderNo: number;

    constructor(
        id: number,
        baseKindId: number,
        title: string,
        color: string,
        textColor: string,
        sysName: string,
        staticForm: boolean,
        orderNo: number,
    ) {
        this.id = id;
        this.baseKindId = baseKindId;
        this.title = title;
        this.color = color;
        this.textColor = textColor;
        this.sysName = sysName;
        this.staticForm = staticForm;
        this.orderNo = orderNo;
    }

    public static fromJson(json: any): BaseInfoModel {
        return new BaseInfoModel(
            json["id"],
            json["baseKindId"],
            json["title"],
            json["color"],
            json["textColor"],
            json["sysName"],
            json["staticForm"],
            json["orderNo"],
        );
    }
}

export interface BaseInfoGetPayloadFilterModel {
    Id: number;
    baseKindId: number;
    title: string;
    sysName: string;
    isActive: number;
    staticForm: number;
}

export interface BaseInfoGetPayloadModel {
    pageSize?: number;
    pageNumber?: number;
    Filters?: BaseInfoGetPayloadFilterModel;
}


export default BaseInfoModel;
